import { MutationOptions } from '@tanstack/react-query';
import { DeactivateQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deactivate/deactivateQueryFunction';
import { DeactivateQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deactivate/deactivateQuery.type';
import { AxiosResponse } from 'axios';

type MutationVariables = {
  id: string;
  formData: DeactivateQueryParamsType;
};

export const deactivateMutationOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  MutationVariables
> => ({
  mutationKey: ['deactivate-participants-incident'],
  mutationFn: ({ id, formData }: MutationVariables) =>
    DeactivateQueryFunction(id, formData),
});
